var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 385,
    viewBox: "0 0 350 385",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_644_890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.174 222.651H81.3647V381.767H280.174V222.651Z",
    fill: "white",
    stroke: "#0C568F",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.174 222.651L312.204 189.87L308.523 337.936L282.751 377.715L280.174 222.651Z",
    fill: "white",
    stroke: "#0C568F",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3644 222.651L46.0205 283.056H238.939L280.174 222.651H81.3644Z",
    fill: "white",
    stroke: "#0C568F",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.174 222.651L305.945 258.01L337.608 209.392L314.045 184.346L280.174 222.651Z",
    fill: "white",
    stroke: "#0C568F",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1509 220.81L146.213 184.346H314.045L280.174 222.651L86.1509 220.81Z",
    fill: "white",
    stroke: "#0C568F",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.628 222.651L46.0205 188.713L112.29 154.143L146.213 184.345L80.628 222.651Z",
    fill: "white",
    stroke: "#0C568F",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.527 68.1806L170.085 35.3903C168.975 33.9601 166.917 33.7007 165.487 34.8108L162.16 37.3945C160.731 38.5047 160.471 40.564 161.581 41.9941L187.023 74.7845C188.133 76.2146 190.191 76.474 191.621 75.3639L194.948 72.7802C196.378 71.6701 196.637 69.6108 195.527 68.1806Z",
    fill: "white",
    stroke: "#0C568F",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.145 48.6186C167.955 48.6186 178.339 38.2297 178.339 25.4143C178.339 12.5989 167.955 2.20996 155.145 2.20996C142.335 2.20996 131.95 12.5989 131.95 25.4143C131.95 38.2297 142.335 48.6186 155.145 48.6186Z",
    fill: "white",
    stroke: "#0C568F",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.609 39.9708C163.844 39.9708 170.52 33.2922 170.52 25.0538C170.52 16.8153 163.844 10.1367 155.609 10.1367C147.374 10.1367 140.698 16.8153 140.698 25.0538C140.698 33.2922 147.374 39.9708 155.609 39.9708Z",
    fill: "white",
    stroke: "#0C568F",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.683 17.753C151.236 16.9414 151.998 16.2936 152.888 15.8776C153.778 15.4616 154.764 15.2926 155.741 15.3884C159.025 15.8009 159.909 17.6646 159.909 17.6646",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.683 17.753C151.236 16.9414 151.998 16.2936 152.888 15.8776C153.778 15.4616 154.764 15.2926 155.741 15.3884C159.025 15.8009 159.909 17.6646 159.909 17.6646",
    stroke: "#0C568F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.459 82.6447C285.143 81.7372 286.054 81.0259 287.1 80.5822C288.146 80.1385 289.29 79.978 290.417 80.1169C291.545 80.2557 292.616 80.689 293.523 81.3733C294.43 82.0575 295.141 82.9685 295.585 84.0148L303.869 103.565L312.145 123.123C312.588 124.17 312.747 125.314 312.608 126.442C312.469 127.57 312.035 128.641 311.351 129.548C310.667 130.455 309.756 131.166 308.71 131.609C307.664 132.052 306.52 132.212 305.393 132.074L284.327 129.473L263.268 126.873C262.142 126.732 261.074 126.298 260.169 125.615C259.264 124.931 258.554 124.021 258.111 122.977C257.668 121.932 257.507 120.79 257.645 119.664C257.782 118.537 258.213 117.467 258.894 116.56L271.676 99.6169L284.459 82.6447Z",
    fill: "white",
    stroke: "#0C568F",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.742 91.3186C292.075 89.7259 291.055 88.1641 289.463 87.8302C287.871 87.4963 286.31 88.5167 285.976 90.1095L282.35 107.413C282.017 109.006 283.037 110.567 284.629 110.901C286.221 111.235 287.782 110.215 288.116 108.622L291.742 91.3186Z",
    fill: "white",
    stroke: "#0C568F",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.839 123.955C285.483 123.955 287.626 121.812 287.626 119.167C287.626 116.523 285.483 114.379 282.839 114.379C280.196 114.379 278.053 116.523 278.053 119.167C278.053 121.812 280.196 123.955 282.839 123.955Z",
    fill: "white",
    stroke: "#0C568F",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M183.714 202.761C184.623 201.934 185.394 200.966 185.997 199.896",
    stroke: "#0C568F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M186.792 192.772C185.04 183.401 176.115 170.473 188.869 145.302C191.733 139.645 187.219 114.798 187.926 104.875C188.552 95.9618 195.496 89.2215 198.507 83.9766",
    stroke: "#0C568F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "9.94 9.94"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M199.833 80.5737C199.932 79.9648 199.891 79.3413 199.714 78.7504C199.537 78.1595 199.227 77.6167 198.809 77.1631",
    stroke: "#0C568F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M181.137 216.389C181.587 214.594 182.447 212.927 183.648 211.52",
    stroke: "#0C568F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M192.388 204.942C201.055 200.426 211.835 198.15 214.257 197.281C219.367 195.447 223.992 192.485 228.52 189.502C239.565 182.231 271.153 166.217 280.453 151.005",
    stroke: "#0C568F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "14.95 14.95"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M282.663 145.981C283.151 144.195 283.181 142.315 282.751 140.515",
    stroke: "#0C568F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.6365 52.1172H7.99654C4.80016 52.1172 2.20898 54.7095 2.20898 57.9072V99.3656C2.20898 102.563 4.80016 105.156 7.99654 105.156H65.6365C68.8329 105.156 71.4241 102.563 71.4241 99.3656V57.9072C71.4241 54.7095 68.8329 52.1172 65.6365 52.1172Z",
    fill: "white",
    stroke: "#0C568F",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.20898 61.6943H69.9514",
    stroke: "#0C568F",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7223 58.6881C12.5031 58.6881 13.1361 58.0549 13.1361 57.2737C13.1361 56.4926 12.5031 55.8594 11.7223 55.8594C10.9416 55.8594 10.3086 56.4926 10.3086 57.2737C10.3086 58.0549 10.9416 58.6881 11.7223 58.6881Z",
    fill: "white",
    stroke: "#0C568F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3625 58.6881C18.1433 58.6881 18.7762 58.0549 18.7762 57.2737C18.7762 56.4926 18.1433 55.8594 17.3625 55.8594C16.5817 55.8594 15.9487 56.4926 15.9487 57.2737C15.9487 58.0549 16.5817 58.6881 17.3625 58.6881Z",
    fill: "white",
    stroke: "#0C568F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2531 58.6881C24.0339 58.6881 24.6669 58.0549 24.6669 57.2737C24.6669 56.4926 24.0339 55.8594 23.2531 55.8594C22.4723 55.8594 21.8394 56.4926 21.8394 57.2737C21.8394 58.0549 22.4723 58.6881 23.2531 58.6881Z",
    fill: "white",
    stroke: "#0C568F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3677 82.6191C26.3677 82.7363 26.27 82.8145 26.0747 82.8535C25.9341 82.877 25.7388 82.8809 25.4888 82.8652C25.1372 82.8418 24.9888 82.8301 25.0435 82.8301C24.7388 82.8301 24.5864 82.9824 24.5864 83.2871C24.5864 83.4746 24.5981 83.7598 24.6216 84.1426C24.645 84.5176 24.6567 84.7988 24.6567 84.9863C24.6567 85.2598 24.5356 85.3965 24.2935 85.3965C21.5981 85.3965 20.1802 85.3613 20.0396 85.291C19.8989 85.2285 19.8286 85.1465 19.8286 85.0449C19.8286 84.9277 19.8755 84.6387 19.9692 84.1777C20.0708 83.7168 20.1216 83.3809 20.1216 83.1699C20.1216 82.9121 19.9771 82.7832 19.688 82.7832C19.1646 82.7832 18.3794 82.7988 17.3325 82.8301C16.2935 82.8613 15.5122 82.877 14.9888 82.877C14.3638 82.877 14.0513 82.6309 14.0513 82.1387C14.0513 81.8887 14.0474 81.5176 14.0396 81.0254C14.0317 80.5254 14.0278 80.1504 14.0278 79.9004C14.0278 79.666 14.1489 79.4199 14.3911 79.1621C15.5317 77.9434 16.3638 76.9668 16.8872 76.2324C17.1372 75.8809 17.9849 74.5098 19.4302 72.1191C19.6177 71.7598 19.9224 71.2676 20.3442 70.6426C20.4536 70.5098 20.5708 70.4434 20.6958 70.4434C20.8833 70.4434 21.4614 70.584 22.4302 70.8652C23.4067 71.1465 24.0708 71.2871 24.4224 71.2871C24.6724 71.2871 24.7974 71.4473 24.7974 71.7676C24.7974 72.0723 24.7622 72.5332 24.6919 73.1504C24.6216 73.7598 24.5864 74.2207 24.5864 74.5332V79.4668C24.7349 79.4668 24.9927 79.4434 25.3599 79.3965C25.688 79.3496 25.9419 79.3262 26.1216 79.3262C26.27 79.3262 26.3442 79.416 26.3442 79.5957C26.3442 79.7598 26.3325 80.0059 26.3091 80.334C26.2935 80.6621 26.2856 80.9121 26.2856 81.084C26.2856 81.2559 26.2974 81.5137 26.3208 81.8574C26.3521 82.1934 26.3677 82.4473 26.3677 82.6191ZM20.5786 75.2129C20.5786 75.166 20.5513 75.1426 20.4966 75.1426C20.4263 75.1426 20.356 75.1934 20.2856 75.2949C19.7856 76.0996 19.2856 76.9043 18.7856 77.709C18.1841 78.6387 17.5981 79.3848 17.0278 79.9473C17.4575 79.9473 18.5513 79.8926 20.3091 79.7832C20.3247 79.4707 20.3794 78.7012 20.4731 77.4746C20.5435 76.5059 20.5786 75.752 20.5786 75.2129ZM41.356 78.1777C41.356 80.1934 40.7036 81.9238 39.3989 83.3691C38.0474 84.8691 36.3716 85.6191 34.3716 85.6191C32.3716 85.6191 30.6997 84.8691 29.356 83.3691C28.0435 81.9238 27.3872 80.1934 27.3872 78.1777C27.3872 76.1543 28.0435 74.4277 29.356 72.998C30.6997 71.5215 32.3716 70.7832 34.3716 70.7832C36.3716 70.7832 38.0435 71.5215 39.3872 72.998C40.6997 74.4355 41.356 76.1621 41.356 78.1777ZM37.0083 78.1777C37.0083 77.373 36.7739 76.6738 36.3052 76.0801C35.8052 75.4473 35.1606 75.1309 34.3716 75.1309C33.5669 75.1309 32.9185 75.4434 32.4263 76.0684C31.9653 76.6465 31.7349 77.3496 31.7349 78.1777C31.7349 78.9902 31.9653 79.6973 32.4263 80.2988C32.9263 80.9473 33.5747 81.2715 34.3716 81.2715C35.1372 81.2715 35.7778 80.9395 36.2935 80.2754C36.77 79.666 37.0083 78.9668 37.0083 78.1777ZM54.7271 82.6191C54.7271 82.7363 54.6294 82.8145 54.4341 82.8535C54.2935 82.877 54.0981 82.8809 53.8481 82.8652C53.4966 82.8418 53.3481 82.8301 53.4028 82.8301C53.0981 82.8301 52.9458 82.9824 52.9458 83.2871C52.9458 83.4746 52.9575 83.7598 52.981 84.1426C53.0044 84.5176 53.0161 84.7988 53.0161 84.9863C53.0161 85.2598 52.895 85.3965 52.6528 85.3965C49.9575 85.3965 48.5396 85.3613 48.3989 85.291C48.2583 85.2285 48.188 85.1465 48.188 85.0449C48.188 84.9277 48.2349 84.6387 48.3286 84.1777C48.4302 83.7168 48.481 83.3809 48.481 83.1699C48.481 82.9121 48.3364 82.7832 48.0474 82.7832C47.5239 82.7832 46.7388 82.7988 45.6919 82.8301C44.6528 82.8613 43.8716 82.877 43.3481 82.877C42.7231 82.877 42.4106 82.6309 42.4106 82.1387C42.4106 81.8887 42.4067 81.5176 42.3989 81.0254C42.3911 80.5254 42.3872 80.1504 42.3872 79.9004C42.3872 79.666 42.5083 79.4199 42.7505 79.1621C43.8911 77.9434 44.7231 76.9668 45.2466 76.2324C45.4966 75.8809 46.3442 74.5098 47.7896 72.1191C47.9771 71.7598 48.2817 71.2676 48.7036 70.6426C48.813 70.5098 48.9302 70.4434 49.0552 70.4434C49.2427 70.4434 49.8208 70.584 50.7896 70.8652C51.7661 71.1465 52.4302 71.2871 52.7817 71.2871C53.0317 71.2871 53.1567 71.4473 53.1567 71.7676C53.1567 72.0723 53.1216 72.5332 53.0513 73.1504C52.981 73.7598 52.9458 74.2207 52.9458 74.5332V79.4668C53.0942 79.4668 53.3521 79.4434 53.7192 79.3965C54.0474 79.3496 54.3013 79.3262 54.481 79.3262C54.6294 79.3262 54.7036 79.416 54.7036 79.5957C54.7036 79.7598 54.6919 80.0059 54.6685 80.334C54.6528 80.6621 54.645 80.9121 54.645 81.084C54.645 81.2559 54.6567 81.5137 54.6802 81.8574C54.7114 82.1934 54.7271 82.4473 54.7271 82.6191ZM48.938 75.2129C48.938 75.166 48.9106 75.1426 48.856 75.1426C48.7856 75.1426 48.7153 75.1934 48.645 75.2949C48.145 76.0996 47.645 76.9043 47.145 77.709C46.5435 78.6387 45.9575 79.3848 45.3872 79.9473C45.8169 79.9473 46.9106 79.8926 48.6685 79.7832C48.6841 79.4707 48.7388 78.7012 48.8325 77.4746C48.9028 76.5059 48.938 75.752 48.938 75.2129Z",
    fill: "#0C568F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4239 119.889C79.5572 119.889 86.1505 113.292 86.1505 105.156C86.1505 97.019 79.5572 90.4229 71.4239 90.4229C63.2906 90.4229 56.6973 97.019 56.6973 105.156C56.6973 113.292 63.2906 119.889 71.4239 119.889Z",
    fill: "white",
    stroke: "#0C568F",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5381 97.4209L83.5733 112.89",
    stroke: "#0C568F",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2197 115.101L81.3643 94.4746",
    stroke: "#0C568F",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M151.684 183.977C144.321 175.874 150.351 172.471 141.744 163.72C137.87 159.786 130.271 154.784 124.808 153.407C114.499 150.806 101.245 148.987 96.8273 147.514C92.1811 145.967 86.5187 140.884 82.8371 136.464C79.8917 132.884 81.3055 127.013 81.7915 122.836",
    stroke: "#0C568F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.286 144.161C221.857 143.74 222.499 141.041 221.72 138.133C220.941 135.225 219.036 133.209 217.465 133.63C215.894 134.051 215.252 136.75 216.03 139.658C216.809 142.566 218.714 144.582 220.286 144.161Z",
    stroke: "#0C568F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.279 139.014C229.092 137.604 227.638 135.242 225.032 133.736C222.426 132.231 219.654 132.153 218.841 133.562C218.027 134.972 219.481 137.335 222.087 138.84C224.693 140.345 227.465 140.423 228.279 139.014Z",
    stroke: "#0C568F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.197 135.365C219.618 133.793 217.603 131.887 214.696 131.108C211.79 130.329 209.092 130.972 208.671 132.543C208.25 134.115 210.265 136.021 213.172 136.801C216.079 137.58 218.776 136.937 219.197 135.365Z",
    stroke: "#0C568F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.122 134.517C221.537 133.703 221.465 130.92 219.96 128.301C218.455 125.682 216.088 124.218 214.673 125.032C213.258 125.845 213.331 128.628 214.835 131.247C216.34 133.867 218.707 135.33 220.122 134.517Z",
    stroke: "#0C568F",
    strokeWidth: 2.00689,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.848 136.268C223.011 133.103 224.934 129.897 224.143 129.106C223.353 128.315 220.147 130.239 216.984 133.403C213.821 136.568 211.898 139.774 212.689 140.565C213.479 141.356 216.685 139.432 219.848 136.268Z",
    fill: "white",
    stroke: "#0C568F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.944 135.491L218.55 138.092",
    stroke: "#0C568F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.588 132.884L221.672 134.969",
    stroke: "#0C568F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.042 183.942C342.614 183.521 343.256 180.822 342.477 177.914C341.698 175.006 339.793 172.99 338.222 173.411C336.651 173.832 336.008 176.531 336.787 179.439C337.566 182.347 339.471 184.363 341.042 183.942Z",
    stroke: "#0C568F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.041 178.787C349.854 177.378 348.401 175.015 345.795 173.51C343.188 172.004 340.416 171.927 339.603 173.336C338.79 174.745 340.243 177.108 342.849 178.613C345.455 180.119 348.227 180.196 349.041 178.787Z",
    stroke: "#0C568F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.961 175.14C340.382 173.568 338.366 171.662 335.46 170.883C332.553 170.103 329.855 170.746 329.434 172.318C329.013 173.89 331.028 175.796 333.935 176.575C336.842 177.354 339.54 176.712 339.961 175.14Z",
    stroke: "#0C568F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.018 173.757C341.427 172.943 341.349 170.17 339.844 167.562C338.34 164.955 335.978 163.501 334.569 164.315C333.161 165.128 333.238 167.902 334.743 170.509C336.248 173.116 338.609 174.57 340.018 173.757Z",
    stroke: "#0C568F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.606 176.045C343.769 172.881 345.692 169.674 344.901 168.883C344.11 168.092 340.905 170.016 337.742 173.18C334.579 176.345 332.656 179.551 333.446 180.343C334.237 181.134 337.443 179.21 340.606 176.045Z",
    fill: "white",
    stroke: "#0C568F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.702 175.27L339.308 177.87",
    stroke: "#0C568F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.347 172.662L342.43 174.747",
    stroke: "#0C568F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2663 153.004C75.1731 152.225 77.1882 150.319 76.7672 148.747C76.3462 147.175 73.6485 146.533 70.7417 147.312C67.8349 148.091 65.8198 149.997 66.2408 151.569C66.6618 153.141 69.3595 153.783 72.2663 153.004Z",
    stroke: "#0C568F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4484 146.94C72.9531 144.332 73.0309 141.559 71.6221 140.745C70.2134 139.932 67.8516 141.386 66.347 143.993C64.8423 146.6 64.7646 149.373 66.1733 150.187C67.582 151.001 69.9438 149.547 71.4484 146.94Z",
    stroke: "#0C568F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4112 155.859C70.1901 152.951 69.5478 150.253 67.9765 149.831C66.4053 149.41 64.5002 151.426 63.7213 154.334C62.9424 157.242 63.5848 159.941 65.156 160.362C66.7272 160.783 68.6324 158.767 69.4112 155.859Z",
    stroke: "#0C568F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3443 155.045C65.9505 153.54 67.4038 151.177 66.5905 149.768C65.7772 148.358 63.0052 148.436 60.399 149.941C57.7929 151.447 56.3395 153.809 57.1528 155.219C57.9662 156.628 60.7382 156.55 63.3443 155.045Z",
    stroke: "#0C568F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1848 156.342C73.9756 155.55 72.0524 152.344 68.8893 149.179C65.7262 146.015 62.5209 144.091 61.7302 144.882C60.9394 145.673 62.8625 148.88 66.0256 152.044C69.1887 155.209 72.394 157.133 73.1848 156.342Z",
    fill: "white",
    stroke: "#0C568F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.103 153.089L70.6875 150.481",
    stroke: "#0C568F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5332 149.443L67.5802 147.329",
    stroke: "#0C568F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M76.917 158.82C81.9857 163.11 87.4919 166.853 93.3445 169.988C97.5932 172.264 102.041 174.238 105.906 177.119C109.772 179.999 126.524 202.069 127.385 206.813",
    stroke: "#0C568F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M196.203 168.529C199.963 165.852 203.071 162.36 205.295 158.315C207.52 154.269 208.804 149.774 209.052 145.163",
    stroke: "#052959",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M273.915 206.813C273.915 200.566 282.987 189.811 292.75 190.864C296.668 191.292 300.408 192.728 304.281 193.413C308.832 194.179 313.496 193.908 317.927 192.621C322.359 191.335 326.443 189.065 329.876 185.98",
    stroke: "#0C568F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "8 8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_644_890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 385,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/error-404.4f3dd60cf08c8b5b03becce40b89e63d.svg";
export { ForwardRef as ReactComponent };